import { attr, fk } from "redux-orm";
import Model from "../base-model";
import projectReducers from "./project.reducer";
import { projectActions } from "./project.action";

/**
 * Project
 * @typedef {Object} Project
 * @property {string} id
 * @property {string} title
 * @property {Date} start
 * @property {Date} end
 */

export class Project extends Model {
    static reducer(action, Self, session) {
        switch (action.type) {
            case projectActions.save:
                projectReducers.save(session, action.project);
                break;
            case projectActions.setFileName:
                projectReducers.setFileName(session, action);
                break;
            case projectActions.setProgress:
                projectReducers.setProgress(session, action);
                break;
            case projectActions.setStatus:
                projectReducers.setStatus(session, action);
                break;
            default:
                return undefined;
        }
    }

    toString() {
        return `Project: ${this.title}`;
    }
}

Project.modelName = "Project";

Project.fields = {
    id: attr(),
    title: attr(),
    start: attr(),
    end: attr(),
    description: attr(),
    descriptionFile: attr(),
    fileName: attr(),
    fileStatus: attr(),
    uploadedProject: attr(),
    uploadProgress: attr(),
    fileVerified: attr(),
    comment: attr(),
    chapter: fk("Chapter", "projects")
};

export class ProjectOverview extends Model {
    static reducer(action, Self, session) {
        switch (action.type) {
            case projectActions.saveCourseProjectOverview:
                projectReducers.saveCourseProjectOverview(
                    session,
                    action.courseId,
                    action.overviewData
                );
                break;
            case projectActions.cleanAllCourseProjectOverview:
                projectReducers.cleanAllCourseProjectOverview(
                    session,
                    action.courseId
                );
                break;
            default:
                return undefined;
        }
    }

    toString() {
        return `ProjectOverview: ${this.title}`;
    }
}

ProjectOverview.modelName = "ProjectOverview";

ProjectOverview.fields = {
    id: attr(),
    title: attr(),
    status: attr(),
    score: attr(),
    course: fk("Course", "projectOverviews")
};
